var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgForBusinessArchitects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111.27 141.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ativo 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.15,59.53H16.56c-2.74,0-2.75,4.27,0,4.27H85.15C87.89,63.8,87.89,59.53,85.15,59.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.15,79H16.56c-2.74,0-2.75,4.26,0,4.26H85.15C87.89,83.24,87.89,79,85.15,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.15,98.43H16.56c-2.74,0-2.75,4.26,0,4.26H85.15C87.89,102.69,87.89,98.43,85.15,98.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.15,117.88H16.56c-2.74,0-2.75,4.26,0,4.26H85.15C87.89,122.14,87.89,117.88,85.15,117.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.8,42.22a5.48,5.48,0,1,0-5.47,5.47A5.48,5.48,0,0,0,23.8,42.22Zm-8.67,0a3.2,3.2,0,1,1,3.2,3.2A3.2,3.2,0,0,1,15.13,42.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.59,47.69a5.47,5.47,0,1,0-5.48-5.47A5.48,5.48,0,0,0,34.59,47.69Zm0-8.67a3.2,3.2,0,1,1-3.2,3.2A3.2,3.2,0,0,1,34.59,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.85,47.69a5.47,5.47,0,1,0-5.47-5.47A5.48,5.48,0,0,0,50.85,47.69Zm0-8.67a3.2,3.2,0,1,1-3.2,3.2A3.21,3.21,0,0,1,50.85,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.12,47.69a5.47,5.47,0,1,0-5.48-5.47A5.47,5.47,0,0,0,67.12,47.69Zm0-8.67a3.2,3.2,0,1,1-3.2,3.2A3.2,3.2,0,0,1,67.12,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.91,42.22a5.48,5.48,0,1,0,5.47-5.47A5.47,5.47,0,0,0,77.91,42.22ZM83.38,39a3.2,3.2,0,1,1-3.2,3.2A3.2,3.2,0,0,1,83.38,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.05,34.88c-1,0-2.26,0-3.69-.09V21.86H90.08A12.63,12.63,0,0,0,94.22,13c0-4.3-2.54-7.52-6.92-8.61-3.21-.79-6-.34-8.21,1.33s-3.62,4.49-4.17,8l-.06-.09c-1.74-2.92-1.17-5.92-.26-9.53a3.21,3.21,0,0,0-2.42-4,3.09,3.09,0,0,0-3.89,2.27c-1.25,4.9-2.1,11.21,2.39,16.56a16.39,16.39,0,0,0,3.23,2.92H0V141.51H104.36V41.35c.91,0,1.83.08,2.76.08h1A3.21,3.21,0,0,0,111.27,38,3.12,3.12,0,0,0,108.05,34.88ZM101,25.27v9.15c-5.68-.87-12.56-3.21-16.84-9.15Zm0,112.83H3.41V25.27h73C80.69,33.92,89.6,39.54,101,41Zm7.1-98.95c-13.82.28-24.89-5.31-29.58-14.91a13.09,13.09,0,0,1-.89-2.44l-.13-.5L77,21.07a14.37,14.37,0,0,1-4.57-3.59c-3.8-4.53-3.11-9.9-1.93-14.55a.78.78,0,0,1,.81-.66,1.39,1.39,0,0,1,.32,0,1,1,0,0,1,.78,1.2c-1,4-1.67,7.59.51,11.25a11.34,11.34,0,0,0,2.14,2.58l1.86,1.71,0-2.52c.08-4.09,1.36-7.38,3.52-9,1.62-1.24,3.74-1.55,6.28-.92C91.32,7.7,92,11.05,92,13c0,3.75-2.75,8.24-7.23,9.26a10.4,10.4,0,0,1-3,.21l-2-.14,1,1.8C87.09,36.23,102,37.26,108.1,37.16h0a.85.85,0,0,1,.88.92A1,1,0,0,1,108.05,39.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.83,19.23c3.78-2.49,3.5-5.25,3.2-6.32a5.8,5.8,0,0,0-5.35-4c-2.57-.11-4.71,1.48-5.74,4.24a10.45,10.45,0,0,0-.18,6l.15.62.61.2a9.61,9.61,0,0,0,3,.5A7.8,7.8,0,0,0,86.83,19.23Zm-6-1.22A7.63,7.63,0,0,1,81.08,14c.68-1.84,1.92-2.84,3.51-2.76a3.59,3.59,0,0,1,3.25,2.32c.35,1.27-.45,2.62-2.26,3.81A5.91,5.91,0,0,1,80.84,18Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgForBusinessArchitects);
export default __webpack_public_path__ + "static/media/imgForBusinessArchitects.8fd651d7f7b7b946f0a67509f311091a.svg";
export { ForwardRef as ReactComponent };